import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipDirective } from '../../directives/tooltip/tooltip.directive';

export type LabelVariant = 'neutral' | 'success' | 'warning' | 'error' | 'empty';
export type LabelBorderStyle = 'rounded' | 'square';
export type LabelSize = 'small' | 'default' | 'large';

@Component({
  selector: 'work-ui-badge',
  standalone: true,
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  imports: [CommonModule, IconComponent, TranslateModule, TooltipDirective],
})
export class BadgeComponent {
  @Input() variant: LabelVariant = 'neutral';
  @Input() borderStyle: LabelBorderStyle = 'rounded';
  @Input() text: string | number = '';
  @Input() title = '';
  @Input() iconName = '';
  @Input() size: LabelSize = 'default';
  @Input() removable = false;
  @Input() clickable = false;
  @Input() disabled = false;
  @Input() textWrap = false;
  @Input() circle = false;
  @Output() labelRemoveClick: EventEmitter<any> = new EventEmitter<any>();

  emitRemoveClick() {
    this.labelRemoveClick.emit();
  }
}
